import { render, staticRenderFns } from "./GridColumn.vue?vue&type=template&id=ccf806a4&functional=true&"
import script from "./GridColumn.vue?vue&type=script&lang=ts&"
export * from "./GridColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports